import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'W6',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M26.18 22.76v-3.19a5.808 5.808 0 0 0 2.91-5.03c0-3.21-2.61-5.82-5.82-5.82-1.16 0-2.24.35-3.15.94-.9-3.87-4.35-6.76-8.48-6.76-4.82 0-8.73 3.91-8.73 8.73 0 2.58 1.13 4.89 2.91 6.49v3.58C2.34 19.69 0 15.94 0 11.64 0 5.21 5.21 0 11.64 0 16 0 19.8 2.41 21.79 5.97c.48-.08.97-.15 1.48-.15 4.82 0 8.73 3.91 8.73 8.73 0 3.79-2.43 7.02-5.82 8.21zm-16-8.21c.8 0 1.45.65 1.45 1.45v11.64a1.451 1.451 0 0 1-2.9 0V16c0-.8.65-1.45 1.45-1.45zm5.82 2.9c.8 0 1.45.65 1.45 1.45v11.64a1.451 1.451 0 0 1-2.9 0V18.91c0-.81.65-1.46 1.45-1.46zm5.82-2.9c.8 0 1.45.65 1.45 1.45v11.64a1.451 1.451 0 0 1-2.9 0V16c-.01-.8.65-1.45 1.45-1.45z" }
      })]
    );
  }
};